// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"f27f778e","404":"5f5868d1","453":"e24ba2e8"}[chunkId] + ".chunk.js";
};